import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from './store';
import { defaultLocale } from './locales/index.js';
Vue.use(VueI18n);

export function loadLocaleMessages() {
  const locales = require.context(
    '@/locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export function checkDefaultLanguage() {
  let matched = null;
  const languages = Object.getOwnPropertyNames(loadLocaleMessages());
  languages.forEach(lang => {
    if (lang === navigator.language) {
      matched = lang;
    }
  });
  if (!matched) {
    languages.forEach(lang => {
      const languagePartials = navigator.language.split('-')[0];
      if (lang === languagePartials) {
        matched = lang;
      }
    });
  }
  if (!matched) {
    languages.forEach(lang => {
      const languagePartials = navigator.language.split('-')[0];
      if (lang.split('-')[0] === languagePartials) {
        matched = lang;
      }
    });
  }
  return matched;
}

const dateTimeFormats = {
  'en-GB': {
    date: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    dateTime: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
  'fi-FI': {
    date: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    dateTime: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
  'sv-SV': {
    date: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    dateTime: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
};

export default new VueI18n({
  locale: store !== undefined ? store.locale : 'fi-FI',
  fallbackLocale: defaultLocale,
  dateTimeFormats,
  //Warnings disabled since missing translations will be up to the client's translator.
  silentTranslationWarn: true,
  messages: loadLocaleMessages(),

});

//export default new VueI18n({
//  //dateTimeFormats,
//  locale: selectedLocale,
//  fallbackLocale: "en",
//  localeDir: 'locales',
//  messages: loadLocaleMessages()
//});
